


























































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { Department } from '@/model/companyStructure/Department'
import { GridOptions } from '@/types'
import FreeShiftPlanningGroupEditorDialog from '@/components/master-data/shifts/FreeShiftPlanningGroupEditorDialog.vue'
import FreeShiftOffsetEditorDialog from '@/components/master-data/shifts/FreeShiftOffsetEditorDialog.vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import ColorPicker from '@/components/ColorPicker.vue'
import { Color } from '@/types'
import { FreeShift } from '@/model/master-data/FreeShift'
import { FreeShiftPlanningGroup } from '@/model/master-data/FreeShiftPlanningGroup'
import { FreeShiftWork } from '@/model/master-data/FreeShiftWork'
import { MasterDataActionsEnum, QcqOperations } from '@/types/enums'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CommentCellRenderer from '@/components/cell-renderer/CommentCellRenderer.vue'
import FreeShiftBreakDialog from '@/components/master-data/shifts/FreeShiftBreakDialog.vue'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import { ShiftBreakPayload } from '@/types/payload'
import { hexToRgba } from '@/services/hex-to-rgba'
import moment from 'moment'

interface ComponentData {
  planningGroupGridOptions: GridOptions
  offsetGridOptions: GridOptions
  showPlanningGroupDialog: boolean
  selectedAddedPlanningGroup: any
  showOffsetDialog: boolean
  showErrorSnackbar: boolean
  errorMessage: string
  isEnableOffsetButtons: boolean
  showDeletePlanningGroupDialog: boolean
  showDeleteOffsetDialog: boolean
  selectedAddedOffset: FreeShiftWork | undefined
  codeValidationRules: Array<Function>
  descriptionValidationRules: Array<Function>
  startValidationRules: Array<Function>
  endValidationRules: Array<Function>
  departmentValidationRules: Array<Function>
  formData: FreeShift | undefined
  planningGroupAction: QcqOperations | undefined
  currentSelectedPlanningGroupId: string
  planningGroupDialogTitle: string
  overlayNoRowsTemplate: string
  gridFrameworkComponents: Object
  breakGridOptions: GridOptions
  selectedBreakData: ShiftBreak | undefined
  currentSelectedBreakId: string | undefined
  showBreakDialog: boolean
  breakDialogTitle: string
  showDeleteBreakDialog: boolean
}

export default Vue.extend({
  name: 'FreeShiftsEditorDialog',

  components: {
    AgGridVue,
    FreeShiftPlanningGroupEditorDialog,
    FreeShiftOffsetEditorDialog,
    ColorPicker,
    DeleteDialog,
    FreeShiftBreakDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    departmentList: {
      type: Array as () => Array<Department>
    },

    allPlanningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },

    selectedDepartmentId: {
      type: Number
    },

    dialogData: {
      type: FreeShift
    },

    loading: {
      type: Boolean
    },

    title: String,
    action: String
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      planningGroupGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.planningGroup'), field: 'planningGroupName' },
          { headerName: this.$t('masterData.shifts.numberOfEmployees'), field: 'numberOfEmployees' },
          { headerName: this.$t('masterData.shifts.offset'), field: 'offset', width: 100 },
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', width: 535, cellRenderer: 'commentCellRenderer' },
        ]
      },

      gridFrameworkComponents: {
        commentCellRenderer: CommentCellRenderer
      },

      offsetGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.work'), field: 'displayLabel' },
          { headerName: this.$t('masterData.shifts.offset'), field: 'offset' },
        ]
      },

      showPlanningGroupDialog: false,
      selectedAddedPlanningGroup: undefined,
      showOffsetDialog: false,
      codeValidationRules: [
        required
      ],
      descriptionValidationRules: [
        required
      ],
      startValidationRules: [
        required
      ],
      endValidationRules: [
        required
      ],
      departmentValidationRules: [
        required
      ],
      showErrorSnackbar: false,
      errorMessage: '',
      isEnableOffsetButtons: false,
      showDeletePlanningGroupDialog: false,
      showDeleteOffsetDialog: false,
      selectedAddedOffset: undefined,
      formData: undefined,
      planningGroupAction: undefined,
      currentSelectedPlanningGroupId: '',
      planningGroupDialogTitle: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      breakGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.start'), field: 'startBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.end'), field: 'endBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.duration'), field: 'duration', width: 100 },
          { headerName: this.$t('masterData.shifts.capacityDeduction'), field: 'deductionCapacity'},
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', cellRenderer: 'commentCellRenderer', width: 535 },
        ]
      },
      selectedBreakData: undefined,
      currentSelectedBreakId: undefined,
      showBreakDialog: false,
      breakDialogTitle: '',
      showDeleteBreakDialog: false
    }
  },

  computed: {
    isEnableBreakButtons (): boolean {
      return !!this.currentSelectedBreakId
    },

    isAddPlanningGroupEnabled (): boolean {
      return !!this.selectedDepartmentId
    },

    isEnableButtons (): boolean {
      return !!this.currentSelectedPlanningGroupId
    },

    isAddOffsetEnabled (): boolean {
      if (this.formData && this.selectedAddedPlanningGroup && this.currentSelectedPlanningGroupId) {
        let foundOffset: Array<FreeShiftWork> = this.formData.workData.filter(
          (item: FreeShiftWork) => item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
        if (this.selectedAddedPlanningGroup.numberOfEmployees > foundOffset.length) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    filteredPlanningGroupList (): Array<PlanningGroup> {
      let filteredPlanningGroup: Array<PlanningGroup>
      if (this.formData && this.planningGroupAction === QcqOperations.ADD) {
        filteredPlanningGroup = _.differenceBy(this.allPlanningGroupList, this.formData.planningGroupData, 'planningGroup')
        return filteredPlanningGroup
      } else if (this.formData && this.allPlanningGroupList && this.planningGroupAction === QcqOperations.EDIT) {
        filteredPlanningGroup = _.differenceBy(this.allPlanningGroupList, this.formData.planningGroupData, 'planningGroup')
        let selectedPlanningGroup: PlanningGroup | undefined = this.allPlanningGroupList.find((item: PlanningGroup) =>
          item.planningGroup === this.selectedAddedPlanningGroup.planningGroup && item.department === this.selectedAddedPlanningGroup.departments)
        if (selectedPlanningGroup) {
          filteredPlanningGroup.push(selectedPlanningGroup)
        }
        return filteredPlanningGroup
      } else {
        return this.allPlanningGroupList
      }
    },

    workList (): Array<FreeShiftWork> | undefined {
      if (this.formData && this.selectedAddedPlanningGroup) {
        return this.formData.workData.filter(
          (item: FreeShiftWork) => item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
      } else {
        return []
      }
    },

    planningGroupList (): Array<FreeShiftPlanningGroup> | undefined {
      if (this.formData) {
        return this.formData.planningGroupData
      } else {
        return undefined
      }
    },

    breakList (): Array<ShiftBreak> | undefined {
      if (this.formData) {
        return this.formData.shiftBreakList
      } else {
        return undefined
      }
    },

    isActiveDisabled (): boolean {
      if(this.action === MasterDataActionsEnum.Create) {
        return true
      } else {
        return false
      }
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    getDuration (): string {
      let duration: string = ''
      if(this.formData && this.formData.start && this.formData.end) {
        let startDuration: number = (moment(this.formData.start, 'HH:mm').hour() * 60) + moment(this.formData.start, 'HH:mm').minutes()
        let endDuration: number = (moment(this.formData.end, 'HH:mm').hour() * 60) + moment(this.formData.end, 'HH:mm').minutes()
        let shiftDuration: number = endDuration - startDuration

        this.formData.shiftBreakList.forEach((item: ShiftBreak) => {
          if(item.startBreak && item.endBreak) {
            let startDuration: number = (moment(item.startBreak, 'HH:mm').hour() * 60) + moment(item.startBreak, 'HH:mm').minutes()
            let endDuration: number = (moment(item.endBreak, 'HH:mm').hour() * 60) + moment(item.endBreak, 'HH:mm').minutes()
            let pauseDuration: number = endDuration - startDuration
            shiftDuration = shiftDuration - pauseDuration
          }
        })

        duration = moment.utc(shiftDuration *60 * 1000).format('HH:mm')
      }

      return duration
    }
  },

  watch: {
    show (newVal: boolean): void {
      if(newVal) {
        this.resetForm()
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
            focusedField.$el.querySelector('input').select()
          }
        }, 0)
      }
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onAddBreakClick (): void {
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.breakDialogTitle = this.$t('masterData.shifts.addBreak').toString()
      this.showBreakDialog = true
    },

    onBreakRowClicked (params: any): void {
      this.currentSelectedBreakId = params.node.data.id
      this.selectedBreakData = params.data
    },

    onEditBreakClick (): void {
      this.breakDialogTitle = this.$t('masterData.shifts.editBreak').toString()
      this.showBreakDialog = true
    },

    onDeleteBreakClick (): void {
      this.showDeleteBreakDialog = true
    },

    onDeleteBreakDialogClose (): void {
      this.showDeleteBreakDialog = false
    },

    deleteBreak (): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1)
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showDeleteBreakDialog = false
    },

    onBreakDialogClose (): void {
      this.showBreakDialog = false
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
    },

    onCreateNewBreak (data: ShiftBreakPayload): void {
      let maxId: ShiftBreak | undefined = _.maxBy(this.breakList, 'id')
      if(this.formData) {
        this.formData.shiftBreakList.push(
          ShiftBreak.create(
            maxId ? maxId.id + 1 : 1,
            this.formData.id ? this.formData.id.toString() : '',
            data.startBreak,
            data.endBreak,
            data.duration,
            data.deductionCapacity,
            data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onEditBreak (data: ShiftBreakPayload): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData && this.currentSelectedBreakId) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1, ShiftBreak.create(
            parseInt(this.currentSelectedBreakId),
            this.formData.id ? this.formData.id.toString() : '',
            data.startBreak,
            data.endBreak,
            data.duration,
            data.deductionCapacity,
            data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onAddPlanningGroupClick (): void {
      this.planningGroupDialogTitle = this.$t('masterData.shifts.addNewFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
      this.planningGroupAction = QcqOperations.ADD
      if (this.formData && this.selectedDepartmentId) {
        const foundItem: Department | undefined = _.find(this.departmentList, { id: this.selectedDepartmentId })
        if (foundItem) {
          this.selectedAddedPlanningGroup = new FreeShiftPlanningGroup(
            this.formData.id,
            undefined,
            1,
            '',
            this.selectedDepartmentId,
            undefined,
            foundItem.label,
            '',
            '00:00'
          )
        }
      }
    },

    onEditPlanningGroupClick (): void {
      if (this.formData) {
        this.selectedAddedPlanningGroup = this.formData.planningGroupData.find((item: FreeShiftPlanningGroup) =>
          item.planningGroup === parseInt(this.currentSelectedPlanningGroupId))
      }
      this.planningGroupDialogTitle = this.$t('masterData.shifts.editFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
      this.planningGroupAction = QcqOperations.EDIT
    },

    onDeletePlanningGroupClick (): void {
      this.showDeletePlanningGroupDialog = true
    },

    deletePlanningGroup () {
      if (this.formData) {
        this.selectedAddedPlanningGroup = this.formData.planningGroupData.find((item: FreeShiftPlanningGroup) =>
          item.planningGroup === parseInt(this.currentSelectedPlanningGroupId))

        let foundItems: Array<FreeShiftWork> = this.formData.workData.filter(
          (item: FreeShiftWork) => this.formData && item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
        this.formData.workData = (_.difference(this.formData.workData, foundItems))
        let index: number = this.formData.planningGroupData.indexOf(this.selectedAddedPlanningGroup)
        this.formData.planningGroupData.splice(index, 1)
      }
      this.showDeletePlanningGroupDialog = false
      this.currentSelectedPlanningGroupId = ''
    },

    onDeletePlanningGroupDialogClose (): void {
      this.showDeletePlanningGroupDialog = false
    },

    onAddOffsetClick (): void {
      this.showOffsetDialog = true
      if (this.formData) {
        this.selectedAddedOffset = new FreeShiftWork(
          this.formData.id,
          this.selectedAddedPlanningGroup.planningGroupId,
          undefined,
          0,
          '',
          this.selectedAddedPlanningGroup.planningGroup,
          '',
          '00:00',
          undefined
        )
      }
    },

    onDeleteOffsetClick (): void {
      this.showDeleteOffsetDialog = true
    },

    deleteOffset () {
      if (this.formData && this.selectedAddedOffset) {
        let index: number = this.formData.workData.indexOf(this.selectedAddedOffset)
        this.formData.workData.splice(index, 1)
      }

      this.showDeleteOffsetDialog = false
      this.isEnableOffsetButtons = false
    },

    onDeleteOffsetDialogClose (): void {
      this.showDeleteOffsetDialog = false
    },

    onPlanningGroupRowClicked (params: any): void {
      this.currentSelectedPlanningGroupId = params.node.data.planningGroup
      this.selectedAddedPlanningGroup = params.data
      this.isEnableOffsetButtons = false
    },

    onOffsetRowClicked (params: any): void {
      this.selectedAddedOffset = params.data
      this.isEnableOffsetButtons = true
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.formData && this.formData.planningGroupData.length > 0) {
          this.$emit('save', this.formData)
        } else {
          this.errorMessage = this.$t('masterData.shifts.withoutPlanningGroupTheDepartmentWillNotBeSaved').toString()
          this.showErrorSnackbar = true
        }
      } else {
        this.errorMessage = this.$t('masterData.shifts.incorrectlyFilledOutForm').toString()
        this.showErrorSnackbar = true
      }
    },

    resetForm () {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }
      this.currentSelectedPlanningGroupId = ''
      this.isEnableOffsetButtons = false

      if (this.dialogData) {
        this.formData = _.cloneDeep(this.dialogData)
      } else {
        this.formData = new FreeShift(
          undefined,
          '',
          '',
          '00:00',
          '00:00',
          0,
          '#fff',
          [],
          [],
          true,
          [],
          '00:00'
        )
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onPlanningGroupDialogClose (): void {
      this.showPlanningGroupDialog = false
    },

    onCreateNewPlanningGroup (payload: FreeShiftPlanningGroup): void {
      if (this.formData) {
        if (this.planningGroupAction === QcqOperations.ADD) {
          this.formData.planningGroupData.push(payload)
        }
        if (this.planningGroupAction === QcqOperations.EDIT) {
          let foundItem: FreeShiftPlanningGroup | undefined = this.formData.planningGroupData.find((item: FreeShiftPlanningGroup) =>
            item.planningGroup === this.selectedAddedPlanningGroup.planningGroup
          )

          let foundOffset: Array<FreeShiftWork> = this.formData.workData.filter(
            (item: FreeShiftWork) => this.formData && item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)

          foundOffset.forEach((item: FreeShiftWork) => {item.planningGroup = payload.planningGroup})

          if (foundItem) {
            this.formData.planningGroupData.splice(this.formData.planningGroupData.indexOf(foundItem), 1, payload)
          }
        }
      }
      this.showPlanningGroupDialog = false
      this.currentSelectedPlanningGroupId = ''
    },

    onOffsetDialogClose (): void {
      this.showOffsetDialog = false
    },

    onCreateNewOffset (payload: FreeShiftWork): void {
      if (this.formData) {
        this.formData.workData.push(payload)
      }
      this.showOffsetDialog = false
    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        if (this.formData) {
          this.formData.color = color.hex
        }
      }
    },

  },

  created () {
    this.formData = new FreeShift(
      undefined,
      '',
      '',
      '00:00',
      '00:00',
      0,
      '',
      [],
      [],
      true,
      [],
      '00:00'
    )
  }

})
